var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFactCheckBlack24Dp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 22,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1.667-3.667h29.333v29.333H-1.667z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#232323",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.778 0H3.222A2.452 2.452 0 00.778 2.444v17.112C.778 20.9 1.878 22 3.222 22h19.556c1.344 0 2.444-1.1 2.444-2.444V2.444C25.222 1.1 24.122 0 22.778 0zm0 19.556H3.222V2.444h19.556v17.112z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.057 9.069L20.32 7.333l-3.874 3.875-1.724-1.736L13 11.196l3.447 3.47zM4.445 4.889h6.11v2.444h-6.11zM4.445 9.778h6.11v2.444h-6.11zM4.445 14.667h6.11v2.444h-6.11z"
  })))));
}
export default SvgFactCheckBlack24Dp;